import background_1 from "../../assets/product_ppt/background_1.png";
import background_2 from "../../assets/product_ppt/background_2.png";
import foot_1 from "../../assets/product_ppt/foot_1.png";
import leaf_1 from "../../assets/product_ppt/leaf_1.png";
export const darkTitle = {
  fontSize: 26,
  fontFace: "Poppins",
  bold: true,
  color: "1A411F",
  lineSpacing: 40,
  align: "left",
  valign: "top",
};
export const darkSubtitle = {
  fontSize: 18,
  fontFace: "Poppins",
  bold: true,
  color: "1A411F",
  align: "left",
  valign: "top",
};
export const darkParagraph = {
  fontSize: 10,
  fontFace: "Poppins",
  color: "1A411F",
  align: "left",
  valign: "top",
  lineSpacing: 15,
};
export const blackParagraph = {
  fontSize: 12,
  fontFace: "Poppins",
  color: "000000",
  characterSpacing: 4,
  align: "left",
  valign: "top",
  lineSpacing: 18,
};
export const blackListitem = {
  fontSize: 12,
  fontFace: "Poppins",
  color: "000000",
  lineSpacing: 18,
  valign: "top",
};
export const whiteSideSubtitleContent = "P R O D U C T  L C A  R E P O R T  2 0 2 5";
export const whiteSideSubtitle = {
  x: -2.5625,
  y: 2.5625,
  w: 5.625,
  h: 0.5,
  fontSize: 8,
  fontFace: "Poppins",
  color: "FFFFFF",
  align: "center",
  rotate: 270,
  fill: { color: "4C7F25" },
};
export const whiteSidePageNumber = {
  x: 0,
  y: 0,
  w: 0.5,
  h: 0.5,
  fontSize: 12,
  fontFace: "Poppins",
  align: "center",
  bold: true,
  color: "FFFFFF",
};
export const greenSubtitle = {
  fontSize: 16,
  fontFace: "Poppins",
  bold: true,
  color: "4C7F25",
  align: "left",
  valign: "top",
};
const goal =
  "To evaluate the environmental impacts associated with the production of 1 m² of acoustic ceiling panel. The results will support decision-making in material selection and design improvements, as well as inform stakeholders on the sustainability performance of the product.";
const scope =
  "This study focuses on a cradle-to-gate life cycle assessment (modules A1–A3) of 1 m² of Acoustic Tile. Use phase (B modules), installation (A4–A5), and end-of-life stages (C modules) are excluded.";
const functional_unit = "1 m2 of Acoustic Ceiling Panel";
const footprint = "18.64";
const assumptions = `Transportation of materials using a 35ft truck at 1% loading efficiency over 100 km from the supplier to the factory.
Canadian average grid electricity is used as an energy input.`;
export const cut_off = `A 1% cut-off is applied at the unit process level and 5% at the module level for mass and energy inputs.
Human-related flows (e.g., employee transport) and biogenic carbon are excluded.`;
export const allocation = `Allocation of environmental impacts is performed based on the mass of each input material, in accordance with ISO 14044 guidelines.`;
export const addImageNonStretch = async (slide, data, maxX, maxY, centerX, centerY) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const wInches = img.width / 96; // px → in
      const hInches = img.height / 96;
      const xZoom = maxX / wInches;
      const yZoom = maxY / hInches;
      const zoom = Math.min(xZoom, yZoom);
      const w = wInches * zoom;
      const h = hInches * zoom;
      const x = centerX - w / 2;
      const y = centerY - h / 2;
      slide.addImage({
        data,
        w,
        h,
        x,
        y,
      });
      resolve();
    };
    img.src = data;
  });
};
export const getBase64 = (url) =>
  fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        })
    );

export const addCoverPage = (pptx, data) => {
  let slide = pptx.addSlide();
  slide.background = { path: background_1 };
  slide.addText("Project Environmental", { x: 0.3, y: 1.97, w: 5, h: 0.79, ...darkTitle });
  slide.addText("Footprint Assessment", { x: 0.3, y: 2.71, w: 5, h: 0.79, ...darkTitle });
  slide.addText("Generated using Arivu.2025", { x: 0.3, y: 4.33, w: 3.05, h: 0.425, ...blackParagraph });
  slide.addText(data?.company?.name || "Company Inc.", { x: 3.8, y: 4.33, w: 2.5, h: 0.52, ...darkSubtitle });
  slide.addText(`${data?.company?.address || "Address"} \n${data?.company?.phone || "Phone"} \n${data?.company?.website || "Website"}`, {
    x: 3.8,
    y: 4.65,
    w: 2.7,
    h: 0.71,
    ...darkParagraph,
  });
};

export const addDescPages = (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addImage({
    path: leaf_1,
    x: 5.5,
    y: 2.65,
    w: 4.44,
    h: 2.95,
  });
  slide.addImage({
    path: foot_1,
    x: 5.6,
    y: 3.2,
    w: 0.35,
    h: 0.635,
  });

  slide.addText("Goal:", { x: 0.75, y: 0.4, w: 4.37, h: 0.4, ...greenSubtitle });
  slide.addText(data.goal, { x: 0.75, y: 0.7, w: 4, h: 1.86, ...blackParagraph });
  slide.addText("Scope:", { x: 0.75, y: 2.7, w: 4.37, h: 0.4, ...greenSubtitle });
  slide.addText(data.scope, { x: 0.75, y: 3, w: 4, h: 1.33, ...blackParagraph });
  slide.addText("Functional Unit:", { x: 0.75, y: 4.4, w: 4.37, h: 0.4, ...greenSubtitle });
  slide.addText(data.functional_unit, { x: 0.75, y: 4.7, w: 4, h: 0.6, ...blackParagraph });
  slide.addText("System Boundary:", { x: 5.5, y: 0.4, w: 4.33, h: 0.4, ...greenSubtitle });
  slide.addText(data.system_boundary, { x: 5.5, y: 0.8, w: 4.33, h: 1.76, ...blackParagraph });
  slide.addText("Project Footprint:", { x: 5.5, y: 2.7, w: 2.77, h: 0.4, ...greenSubtitle });
  slide.addText("GWP = " + data.footprint + " kgCO2e", { x: 6, y: 3.15, w: 2.27, h: 0.79, ...blackParagraph });
  slide.addShape(pptx.ShapeType.rect, {
    x: 5.2,
    y: 0.4,
    w: 0.02,
    h: 4.8,
    fill: "EAC222",
  });
  num++;
  let slide2 = pptx.addSlide();
  slide2.background = { path: background_2 };
  slide2.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide2.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide2.addText("Assumptions", { x: 0.75, y: 0.5, w: 5.53, h: 0.35, ...greenSubtitle });
  slide2.addText(data.assumptions, { x: 0.75, y: 0.85, w: 5.53, h: 0.85, ...blackParagraph });
  slide2.addText("Cut-off", { x: 0.75, y: 1.95, w: 5.53, h: 0.35, ...greenSubtitle });
  slide2.addText(cut_off, { x: 0.75, y: 2.25, w: 5.53, h: 0.85, ...blackParagraph });
  slide2.addText("Allocation", { x: 0.75, y: 3.55, w: 5.53, h: 0.35, ...greenSubtitle });
  slide2.addText(allocation, { x: 0.75, y: 3.85, w: 5.53, h: 0.85, ...blackParagraph });
  num++;
  return num;
};
export const addInsights = (pptx, data, pageNum) => {
  let insightsBlocks = [];
  let maxLetters = 1000;
  let currentBlock = [];
  let currentCount = 0;
  let num = pageNum;
  if (!data.insights) {
    return num;
  }
  for (const item of data.insights) {
    const length = item.length;
    if (currentCount + length > maxLetters && currentBlock.length > 0) {
      insightsBlocks.push(currentBlock);
      currentBlock = [];
      currentCount = 0;
    }
    currentBlock.push(item);
    currentCount += length;
  }
  insightsBlocks.push(currentBlock);
  for (const item of insightsBlocks) {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("AI-generated insights", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
    slide.addText(
      item.map((i) => ({ text: i, options: { bullet: true, paraSpaceAfter: 10 } })),
      { x: 0.75, y: 0.85, w: 9, h: 4.4, ...blackListitem }
    );
    num++;
  }
  return num;
};

export const addHotspots = (pptx, data, pageNum) => {
  let tableBlocks = [];
  let maxLetters = 500;
  let currentBlock = [];
  let currentCount = 0;
  let num = pageNum;
  if (!data.env_hotspot) {
    return num;
  }
  for (const item of data.env_hotspot) {
    const length = Math.max(item.category.length, item.hotspot.length, item.recommendation.length);
    if (currentCount + length > maxLetters && currentBlock.length > 0) {
      tableBlocks.push(currentBlock);
      currentBlock = [];
      currentCount = 0;
    }
    currentBlock.push(item);
    currentCount += length;
  }
  tableBlocks.push(currentBlock);
  for (const item of tableBlocks) {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("Environmental Hotspots", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
    const tableData = [["Category", "Hotspot", "Recommendation"], ...item.map((i) => [i.category, i.hotspot, i.recommendation])];
    const tableRows = tableData.map((row, rowIndex) =>
      row.map((cell, colIndex) => {
        if (rowIndex === 0) {
          return {
            text: cell,
            options: {
              fill: "5F7434",
              color: "FFFFFF",
              bold: true,
              border: { pt: 1, color: "4C7F25" },
              align: "center",
              valign: "middle",
            },
          };
        } else if (colIndex === 0) {
          return {
            text: cell,
            options: {
              color: "4C7F25",
              border: { pt: 1, color: "4C7F25" },
              align: "left",
              valign: "middle",
            },
          };
        } else {
          return {
            text: cell,
            options: {
              color: "000000",
              border: { pt: 1, color: "4C7F25" },
              align: "left",
              valign: "middle",
            },
          };
        }
      })
    );
    slide.addTable(tableRows, { x: 0.8, y: 0.8, w: 8.7, colW: [2, 2.9, 3.8], fontSize: 12, fontFace: "Poppins" });
    num++;
  }
  return num;
};

export const addReferences = (pptx, data, pageNum) => {
  if (!data.lca_info || !data.lca_info.formattedReferences) {
    return pageNum;
  }
  const bullets = data.lca_info.formattedReferences
    .split("\n")
    .map((b) => b.trim().replace("•", ""))
    .filter(Boolean);
  let bulletBlocks = [];
  let maxLetters = 1000;
  let currentBlock = [];
  let currentCount = 0;
  let num = pageNum;
  for (const item of bullets) {
    const length = item.length;
    if (currentCount + length > maxLetters && currentBlock.length > 0) {
      bulletBlocks.push(currentBlock);
      currentBlock = [];
      currentCount = 0;
    }
    currentBlock.push(item);
    currentCount += length;
  }
  bulletBlocks.push(currentBlock);
  for (const item of bulletBlocks) {
    let slide = pptx.addSlide();
    slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
    slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
    slide.addText("References", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
    slide.addText(
      item.map((i) => ({ text: i, options: { bullet: true, paraSpaceAfter: 10 } })),
      { x: 0.75, y: 0.85, w: 9, h: 4.4, ...blackListitem }
    );
    num++;
  }
  return num;
};

export const addSystemBoundary = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addText("System Boundary", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
  if (data.systemBoundary) {
    await addImageNonStretch(slide, data.systemBoundary, 9, 4.1, 5.1, 2.97);
  }
  num++;
  return num;
};

export const addLifeCycleStages = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addText("Life Cycle Stages Breakdown", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
  if (data.sankeyDiagram) {
    await addImageNonStretch(slide, data.sankeyDiagram, 9, 4.1, 5.1, 2.97);
  }
  num++;
  return num;
};

export const addCircularity = async (pptx, data, pageNum, title = "Product Circularity") => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addText(title, { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
  if (data.nomalizedGWPChart) {
    await addImageNonStretch(slide, data.nomalizedGWPChart, 9, 4.1, 5.1, 2.97);
  }
  num++;
  return num;
};

export const addEnvFootprint = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addText("Environmental Footprint Summary", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
  if (data.footprintSummary) {
    await addImageNonStretch(slide, data.footprintSummary, 9, 4.5, 5.1, 2.97);
  }
  num++;
  return num;
};

export const addDetailedSummary = async (pptx, data, pageNum) => {
  let slide = pptx.addSlide();
  let num = pageNum;
  slide.addText(whiteSideSubtitleContent, whiteSideSubtitle);
  slide.addText(num.toLocaleString("en-US", { minimumIntegerDigits: 2 }), whiteSidePageNumber);
  slide.addText("Detailed Process Summary", { x: 0.75, y: 0.2, w: 5.5, h: 0.55, ...greenSubtitle });
  if (data.detailedSummary) {
    await addImageNonStretch(slide, data.detailedSummary, 9, 4.5, 5.1, 2.97);
  }
  num++;
  return num;
};
